import { UseQueryDefaultOptions } from '@front/hook/Api/common';
import { DEFAULT_TIMEOUT } from '@front/hook/Api/utils/consts';
import { signalToTimeout } from '@front/hook/Api/utils/signalToTimeout';
import { SourceSystemRepository } from '@front/repository/Api/SourceSystem';
import { useQuery } from '@tanstack/react-query';
import { AuthDomain } from 'auth-lib-front';
import { DomainV2 } from 'troppus-common/domain';

import Project = AuthDomain.Object.Project;
import SourceSystem = DomainV2.Import.SourceSystem;

import { sourceSystemQueryKeys } from './queryKeys';

const repository = new SourceSystemRepository();

type Params = {
  projectId: Project.Id;
  id: SourceSystem.Id | undefined;
};

type Options = {
  enabled?: boolean;
};

export const _get = ({ projectId, id }: Params, options?: Options) => {
  return useQuery({
    queryKey:
      id !== undefined
        ? sourceSystemQueryKeys.detail(projectId, id)
        : (['troppus', 'sourceSystem', 'detail', projectId, 'pending'] as const),
    queryFn: async ({ signal }) => {
      if (id === undefined) return undefined;
      return repository.get({ projectId, id }, { signal: signalToTimeout(DEFAULT_TIMEOUT.QUERY, signal) });
    },
    enabled: (options?.enabled ?? true) && id !== undefined,
    ...UseQueryDefaultOptions,
  });
};
